module.exports = __webpack_public_path__ + "static/media/LHInSwingDark.c1a5a0db.svg";